var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page && _vm.isTC)?_c('div',{staticClass:"tc-page-loading"},[_c('Loader')],1):_c('Loader',_vm._b({},'Loader',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }